import React from 'react';
import { useParams, Link } from 'react-router-dom';

// REAL HOURS: from Google Sheet
// FAKE HOURS (Contact clinic): Rohit Mehta, Dr. Neha, Kapoors, Monika, Paras, Venkata Kripa
// Only real data from PDF + Google Sheet is used here

const allDoctors = [
  {
    id: 1,
    name: 'Dr. Mayank Nagpal',
    specialty: 'Dentist',
    qual: 'BDS, MDS - Periodontist & Implantologist',
    city: 'Gurgaon',
    location: '532/1, New Railway Road, Near Bheem Nagar Chowk, Gurugram',
    clinic: 'Vedanta Dental Clinic',
    fee: 1000,
    initials: 'MN',
    color: '#185FA5',
    hours: 'Mon–Sat: 10:00 AM–8:00 PM | Sun: 10:30 AM–3:00 PM',
    phone: '9467251150',
    website: '',
    about: 'Dr. Mayank Nagpal (BDS, MDS) is a Periodontist and Implantologist at Vedanta Dental Clinic, New Railway Road, Gurugram. Established in 2015, the clinic specialises in dental implants, gum surgery, painless dentistry, and full mouth rehabilitation.',
    services: ['Dental Implants', 'Gum Surgery (Periodontal)', 'Painless Dentistry', 'Full Mouth Rehabilitation', 'Clear Aligners', 'Braces', 'Teeth Whitening', 'Root Canal Treatment', 'Crowns & Bridges', 'Scaling & Polishing'],
    specializations: ['Periodontist', 'Implantologist'],
    education: [{ degree: 'BDS' }, { degree: 'MDS - Periodontology & Oral Implantology' }],
    memberships: [],
    awards: [],
  },
  {
    id: 2,
    name: 'Dr. Deepanshu Malik',
    specialty: 'Dentist',
    qual: 'BDS - Orthodontist & Implantologist',
    city: 'Gurgaon',
    location: 'A-112, First Floor, Vatika Town Square, Sector 82, Gurugram',
    clinic: 'Careocity Dental | Clear Aligners, Braces & Implants Centre',
    fee: 1000,
    initials: 'DM',
    color: '#D85A30',
    hours: 'All days: 10:00 AM–8:00 PM',
    phone: '9717944799',
    website: 'www.careocity.in',
    about: 'Dr. Deepanshu Malik and Dr. Ankita Malik run Careocity Dental at Vatika Town Square, Sector 82, Gurugram — a comprehensive dental clinic established in 2019, serving patients from Sector 77 to Sector 95. The clinic specialises in orthodontics, clear aligners, braces, and implants.',
    services: ['Clear Aligners', 'Braces & Orthodontics', 'Dental Implants', 'Root Canal Treatment', 'Crowns & Bridges', 'Teeth Whitening', 'Scaling & Polishing', 'Smile Designing'],
    specializations: ['Orthodontist', 'Implantologist'],
    education: [{ degree: 'BDS' }],
    memberships: [],
    awards: [],
  },
  {
    id: 3,
    name: 'Dr. Utkarsh Singh',
    specialty: 'Dentist',
    qual: 'BDS',
    city: 'Lucknow',
    location: '1/246, Viram Khand 1, Gomti Nagar, Lucknow',
    clinic: 'Cosmodont Dental Clinic',
    fee: 1000,
    initials: 'US',
    color: '#3B6D11',
    hours: 'All days except Friday: 10:00 AM–9:00 PM',
    phone: '7992074028',
    website: 'https://cosmodontdentalclinics.com/',
    about: 'Dr. Utkarsh Singh runs Cosmodont Dental Clinic in Gomti Nagar, Lucknow — established in 2021, offering invisible aligners, Invisalign, dental implants, smile designing, painless root canal, veneers, and cosmetic dentistry.',
    services: ['Invisible Aligners', 'Invisalign', 'Dental Implants', 'Smile Designing', 'Painless Root Canal', 'Crowns & Bridges', 'Veneers', 'Zirconia Crowns', 'Teeth Whitening', 'Cosmetic Dentistry', 'Paediatric Dentistry', 'Sports Dentistry'],
    specializations: ['Cosmetic Dentist', 'Implantologist', 'Orthodontist'],
    education: [{ degree: 'BDS' }],
    memberships: [],
    awards: [],
  },
  {
    id: 4,
    name: 'Dr. Rohit Mehta',
    specialty: 'Dentist',
    qual: 'BDS',
    city: 'Gurgaon',
    location: 'Shop No. 5, Near Reshape Fitness Gym, Sector 7, Kataria Market, Gurugram',
    clinic: "Grins 'n' Giggles Dental Care",
    fee: 1000,
    initials: 'RM',
    color: '#993556',
    hours: 'Contact clinic for timings',
    phone: '',
    website: '',
    about: "Dr. Rohit Mehta runs Grins 'n' Giggles Dental Care in Sector 7, Kataria Market, Gurugram — a dental clinic focused on general and paediatric dentistry.",
    services: ['General Dentistry', 'Paediatric Dentistry', 'Tooth Extraction', 'Dental Fillings', 'Scaling & Polishing', 'Root Canal Treatment', 'Dental Crowns'],
    specializations: ['General Dentist', 'Paediatric Dentist'],
    education: [{ degree: 'BDS' }],
    memberships: [],
    awards: [],
  },
  {
    id: 5,
    name: 'Dr. Neha',
    specialty: 'Dentist',
    qual: 'BDS',
    city: 'Gurgaon',
    location: '436/9, Old Railway Road, Shivpuri, Gurugram',
    clinic: 'Magical 32',
    fee: 1000,
    initials: 'NE',
    color: '#534AB7',
    hours: 'Contact clinic for timings',
    phone: '',
    website: '',
    about: 'Dr. Neha practices at Magical 32 Dental Clinic on Old Railway Road, Shivpuri, Gurugram — offering comprehensive dental care in a comfortable, patient-friendly environment.',
    services: ['General Dentistry', 'Tooth Extraction', 'Dental Fillings', 'Root Canal Treatment', 'Scaling & Polishing', 'Crowns & Bridges'],
    specializations: ['General Dentist'],
    education: [{ degree: 'BDS' }],
    memberships: [],
    awards: [],
  },
  {
    id: 6,
    name: 'Dr. Ruchir Kapoor & Dr. Lovleen Puri Kapoor',
    specialty: 'Dentist',
    qual: 'BDS',
    city: 'Gurgaon',
    location: 'Sector 57, Gurugram',
    clinic: "Dr. Kapur's Crowns & Canals Dental Clinic",
    fee: 1000,
    initials: 'KC',
    color: '#0F6E56',
    hours: 'Contact clinic for timings',
    phone: '',
    website: '',
    about: "Dr. Ruchir Kapoor and Dr. Lovleen Puri Kapoor run Dr. Kapur's Crowns & Canals Dental Clinic in Sector 57, Gurugram — specialising in root canal treatment, crowns, bridges, and restorative dentistry.",
    services: ['Root Canal Treatment', 'Dental Crowns', 'Bridges', 'Dental Fillings', 'Scaling & Polishing', 'Tooth Extraction', 'Cosmetic Dentistry'],
    specializations: ['Endodontist', 'Restorative Dentist'],
    education: [{ degree: 'BDS' }],
    memberships: [],
    awards: [],
  },
  {
    id: 7,
    name: 'Dr. Sudeep Kumar',
    specialty: 'Physiotherapist',
    qual: 'Physiotherapy, Speech & Swallowing Therapy, Chiropractic',
    city: 'Gurgaon',
    location: 'Shop No. 3, Ashok Vihar Phase III Extension, Gurugram',
    clinic: 'Dinanath Physiotherapy & Wellness Center',
    fee: 1000,
    initials: 'SK',
    color: '#A32D2D',
    hours: 'All days: 7:00 AM–9:00 PM',
    phone: '9653466432',
    website: '',
    about: 'Dr. Sudeep Kumar runs Dinanath Physiotherapy & Wellness Center in Ashok Vihar Phase III Extension, Gurugram — established in 2018, serving Gurugram & Delhi NCR. The clinic specialises in physiotherapy, speech therapy, swallowing therapy (Dysphagia), and chiropractic care.',
    services: ['Physiotherapy', 'Speech Therapy', 'Swallowing Therapy (Dysphagia)', 'Chiropractic Care', 'Neurological Rehabilitation', 'Orthopaedic Physiotherapy', 'Sports Injury Rehabilitation'],
    specializations: ['Physiotherapist', 'Speech Therapist', 'Chiropractor'],
    education: [],
    memberships: [],
    awards: [],
  },
  {
    id: 8,
    name: 'Dr. Saroj Rustgi',
    specialty: 'Physiotherapist',
    qual: 'BPT, MPT — 40+ years experience',
    city: 'Gurgaon',
    location: 'Block B-279, Sushant Lok 3, Sector 57, Gurugram',
    clinic: 'Wellness First Physiotherapy',
    fee: 1000,
    initials: 'SR',
    color: '#185FA5',
    hours: 'Mon–Sat: 8:30 AM–2:00 PM & 4:30 PM–8:30 PM | Sun: 9:00 AM–12:30 PM',
    phone: '7838455530',
    website: 'https://wellnessfirstphysio.in',
    about: 'Dr. Saroj Rustgi (PT) is a senior physiotherapist with 40+ years of experience, formerly Head of Physiotherapy at Northern Railway Central Hospital. She has been running Wellness First Physiotherapy in Sushant Lok 3, Sector 57, Gurugram since 2013.',
    services: ['Exercise Therapy', 'Balance & Coordination Training', 'Gait Training', 'TENS', 'IFT', 'Muscle Stimulation', 'Short Wave Diathermy', 'LASER Therapy', 'Manual Therapy', 'Trigger Point Therapy', 'Joint Mobilization', 'Myofascial Release', 'Stroke Rehabilitation', 'Knee Replacement Rehab', 'Hip Replacement Rehab', 'Back Pain Treatment', 'Neck Pain Treatment', 'Home Physiotherapy Services'],
    specializations: ['Musculoskeletal & Sports Physiotherapist', 'Neurological Rehabilitation'],
    education: [{ degree: 'BPT / MPT' }],
    memberships: [],
    awards: ['Formerly Head of Physiotherapy — Northern Railway Central Hospital'],
  },
  {
    id: 9,
    name: 'Dr. Kinju Mishra',
    specialty: 'Physiotherapist',
    qual: 'BPT — Sports & Orthopaedic Physiotherapist',
    city: 'Gurgaon',
    location: 'Nirvana Country, Sector 50, Gurugram',
    clinic: 'Nirvana Speciality Clinics',
    fee: 1000,
    initials: 'KM',
    color: '#3B6D11',
    hours: 'Mon–Sat: 9:00 AM–9:00 PM | Sun: Closed',
    phone: '7005231035',
    website: '',
    about: 'Dr. Kinju Mishra is a Consultant Physiotherapist at Nirvana Speciality Clinics, Sector 50, Gurugram — specialising in sports and orthopaedic physiotherapy. She treats sports-related injuries, ACL rehabilitation, shoulder, knee and ankle conditions, and back and neck pain.',
    services: ['Sports Injury Rehabilitation', 'ACL Rehabilitation', 'Meniscus Injury Treatment', 'Knee Pain Therapy', 'Shoulder Injury Rehab', 'Rotator Cuff Tear Rehab', 'Ankle Rehabilitation', 'Back Pain Treatment', 'Neck Pain Treatment', 'Orthopaedic Physiotherapy'],
    specializations: ['Sports Physiotherapist', 'Orthopaedic Physiotherapist'],
    education: [{ degree: 'BPT' }],
    memberships: [],
    awards: [],
  },
  {
    id: 10,
    name: 'Ms. Mansi Chawla',
    specialty: 'Psychotherapist',
    qual: 'MA — Psychotherapy & Counselling | Certified CBT, EMDR & Hypnotherapy',
    city: 'Delhi',
    location: 'W-21/26, Western Avenue, Sainik Farms, New Delhi',
    clinic: 'Mansi Chawla Psychotherapy & Counselling',
    fee: 1000,
    initials: 'MC',
    color: '#993556',
    hours: 'Mon–Sun: 10:00 AM–8:00 PM',
    phone: '7678644115',
    website: 'www.mansichawla.in',
    about: 'Mansi Chawla is an award-winning psychotherapist registered with MHI (Mental Health International) and the Counsellors Council of India (CCI). Trained by NHCA Singapore, she holds a Master\'s in Psychotherapy & Counselling and is certified in CBT, EMDR, Hypnotherapy, Psycho-oncology, Past Life Therapy, Behaviour Therapy, and Clinical Psychology. She has trained over 2000 teachers in children\'s mental health.',
    services: ['Depression & Anxiety Management', 'Marriage & Relationship Counselling', 'Family Therapy', 'CBT', 'EMDR Therapy', 'Hypnotherapy', 'Stress Management', 'Crisis Intervention', 'Psycho-oncology', 'Behaviour Therapy', 'Special Education Support', 'Past Life Therapy'],
    specializations: ['Psychotherapist', 'Marriage & Family Therapist', 'CBT Specialist', 'EMDR Practitioner'],
    education: [{ degree: 'MA — Psychotherapy & Counselling' }, { degree: 'Trained by NHCA Singapore' }],
    memberships: ['MHI — Mental Health International', 'Counsellors Council of India (CCI)'],
    awards: ['Award-winning Psychotherapist', 'Chief Counsellor — Leading Schools'],
  },
  {
    id: 11,
    name: 'Dr. Ritu Aggarwal',
    specialty: 'Psychotherapist',
    qual: 'Psychological Counselling & Psychotherapy | CBT, ACT',
    city: 'Bangalore',
    location: 'Regenique Clinic, Whitefield Hoskote Road, Above Starbucks, Ardendale, Bengaluru',
    clinic: 'Innerwork Helps — Psychotherapy & Counselling',
    fee: 1000,
    initials: 'RA',
    color: '#534AB7',
    hours: 'Mon–Sat: 9:00 AM–6:00 PM',
    phone: '8095929255',
    website: 'www.innerworkhelps.com',
    about: 'Dr. Ritu Aggarwal runs Innerwork Helps at Regenique Clinic, Whitefield, Bengaluru — offering psychological counselling and psychotherapy for anxiety, depression, emotional difficulties, relationship issues, and exam anxiety using CBT, ACT, and other evidence-based approaches.',
    services: ['Anxiety Treatment', 'Depression Management', 'CBT', 'ACT', 'Panic Disorder Treatment', 'Relationship Issues Counselling', 'Emotional Difficulties', 'Exam Anxiety', 'Stress Management'],
    specializations: ['Psychotherapist', 'CBT Therapist', 'ACT Therapist'],
    education: [],
    memberships: [],
    awards: [],
  },
  {
    id: 12,
    name: 'Dr. Lubna Kamal',
    specialty: 'Homeopathy',
    qual: 'BHMS — Homeopathic Physician',
    city: 'Lucknow',
    location: 'B-703, Mahanagar, Channilal Chauraha, Lucknow',
    clinic: 'Nano Homeopathy Institute of Research & Welfare',
    fee: 1000,
    initials: 'LK',
    color: '#BA7517',
    hours: '365 Days: 10:00 AM–8:00 PM',
    phone: '9450630019',
    website: 'https://www.kidneyfailure.co.in/',
    about: 'Dr. Lubna Kamal runs Nano Homeopathy Institute of Research & Welfare in Mahanagar, Lucknow — established in 2005, open 365 days a year. The clinic specialises in chronic kidney disease, kidney failure, liver disorders, cancer supportive care, diabetes, PCOS, rheumatoid arthritis, and other chronic conditions. Offers online consultations and worldwide medicine delivery using ISO-certified homeopathic medicines.',
    services: ['Chronic Kidney Disease (CKD) Management', 'Kidney Failure Supportive Care', 'Liver Cirrhosis & Fatty Liver Treatment', 'Cancer Supportive Care', 'Diabetes Complications Management', 'PCOS & Menstrual Disorders', 'Rheumatoid Arthritis', 'Psoriasis', 'Thyroid Disorders', 'Diet & Nutrition Guidance', 'Yoga & Exercise Guidance', 'Online Homeopathy Consultation', 'Medicine Delivery Nationwide'],
    specializations: ['Homeopathic Physician', 'Kidney & Chronic Disease Specialist'],
    education: [{ degree: 'BHMS' }],
    memberships: [],
    awards: [],
  },
  {
    id: 13,
    name: 'Dr. Puja Dhande',
    specialty: 'Occupational Therapist',
    qual: 'BOT — Paediatric Occupational Therapist',
    city: 'Pune',
    location: '803, SELENITE Tower, Inside Whispering Winds Society, Baner Pashan Link Road, Pune',
    clinic: 'Milestones Occupational Therapy & Child Development Centre',
    fee: 1000,
    initials: 'PD',
    color: '#0F6E56',
    hours: 'Mon–Sat: 10:00 AM–7:00 PM | Sun: Closed',
    phone: '9529758289',
    website: 'www.milestonesotclinic.com',
    about: 'Dr. Puja Dhande runs Milestones Occupational Therapy and Child Development Centre in Baner, Pune — established June 2025. The clinic treats neurodevelopmental differences through Occupational Therapy, Sensory Integration, Speech Therapy, Behaviour Therapy, Reflex Integration, Play Therapy, and Special Education.',
    services: ['Occupational Therapy', 'Sensory Integration Therapy', 'Speech Therapy', 'Behaviour Therapy', 'Special Education', 'Autism Therapy', 'ADHD Management', 'Reflex Integration', 'Play Therapy', 'Parent Counselling'],
    specializations: ['Paediatric Occupational Therapist', 'Sensory Integration Specialist'],
    education: [{ degree: 'BOT — Occupational Therapy' }],
    memberships: [],
    awards: [],
  },
  {
    id: 14,
    name: 'Dr. Monika Chauhan',
    specialty: 'Nutritionist',
    qual: 'Nutrition & Dietetics',
    city: 'Gurgaon',
    location: 'Plot No. 21, Circular Road, New Colony, Gurugram',
    clinic: 'Everyday Nourish Health & Wellness Diet Clinic',
    fee: 1000,
    initials: 'MC',
    color: '#2e7d32',
    hours: 'Contact clinic for timings',
    phone: '',
    website: '',
    about: 'Dr. Monika Chauhan runs Everyday Nourish Health & Wellness Diet Clinic at New Colony, Gurugram — a dedicated nutrition and wellness clinic offering personalised diet planning, weight management, and therapeutic nutrition counselling.',
    services: ['Weight Management', 'Therapeutic Diet Planning', 'Diabetes Nutrition', 'PCOS Diet Counselling', 'Sports Nutrition', 'Child Nutrition', 'Gut Health Management', 'Lifestyle & Wellness Coaching'],
    specializations: ['Clinical Nutritionist', 'Dietitian'],
    education: [],
    memberships: [],
    awards: [],
  },
  {
    id: 15,
    name: 'Dr. Sandeep Sangwan',
    specialty: 'Pediatrician',
    qual: 'MBBS, MD — Paediatrics',
    city: 'Gurgaon',
    location: 'A-237, 40 Ft Road, Near Dwarka Expressway, New Palam Vihar, Sector 110, Gurugram',
    clinic: "Rion's Hospital | Pediatric & Multi Speciality",
    fee: 1000,
    initials: 'SS',
    color: '#185FA5',
    hours: '24x7 Open',
    phone: '',
    website: 'https://rionshospital.com',
    about: "Dr. Sandeep Sangwan is a senior doctor at Rion's Hospital — a Pediatric & Multi-Speciality hospital at Sector 110, New Palam Vihar, Gurugram, open 24x7. The hospital offers paediatrics, gynaecology, ENT, diagnostics, and emergency care.",
    services: ['Paediatrics', 'General Medicine', 'Emergency Care (24x7)', 'Multi-Specialty OPD', 'IPD Services', 'Vaccination', 'Child Health Checkup'],
    specializations: ['Paediatrician', 'Multi-Specialty Physician'],
    education: [{ degree: 'MBBS, MD' }],
    memberships: [],
    awards: [],
  },
  {
    id: 16,
    name: 'Dr. Amandeep Kaur',
    specialty: 'Gynecologist',
    qual: 'MBBS, MS — Obstetrics & Gynaecology',
    city: 'Gurgaon',
    location: 'A-237, 40 Ft Road, Near Dwarka Expressway, New Palam Vihar, Sector 110, Gurugram',
    clinic: "Rion's Hospital | Pediatric & Multi Speciality",
    fee: 1000,
    initials: 'AK',
    color: '#993556',
    hours: '24x7 Open',
    phone: '',
    website: 'https://rionshospital.com',
    about: "Dr. Amandeep Kaur is a Gynaecologist and Obstetrician at Rion's Hospital, Sector 110, Gurugram — handling routine and complicated pregnancy cases, gynaecological laparoscopy, and women's health.",
    services: ['Obstetrics & Gynaecology', 'Complicated Pregnancy Treatment', 'Gynaecological Laparoscopy', 'Antenatal Care', 'Postnatal Care', 'Family Planning', "Women's Health Checkup"],
    specializations: ['Gynaecologist', 'Obstetrician'],
    education: [{ degree: 'MBBS, MS — Obstetrics & Gynaecology' }],
    memberships: [],
    awards: [],
  },
  {
    id: 17,
    name: 'Dr. Abhimanyu Sangwan',
    specialty: 'ENT Specialist',
    qual: 'MBBS, MS — ENT / Otorhinolaryngologist',
    city: 'Gurgaon',
    location: 'A-237, 40 Ft Road, Near Dwarka Expressway, New Palam Vihar, Sector 110, Gurugram',
    clinic: "Rion's Hospital — Head of ENT Department",
    fee: 1000,
    initials: 'AS',
    color: '#0F6E56',
    hours: '24x7 Open',
    phone: '',
    website: 'https://rionshospital.com',
    about: "Dr. Abhimanyu Sangwan is an ENT Specialist and Head of the ENT Department at Rion's Hospital, Sector 110, Gurugram — specialising in ear, nose, and throat surgeries, sinusitis, tonsillitis, and hearing disorders.",
    services: ['ENT Consultation', 'Sinusitis Treatment & Surgery', 'Tonsillectomy', 'Ear Surgery', 'Hearing Assessment', 'Nasal Polyp Removal', 'Septoplasty', 'Throat Disorders'],
    specializations: ['ENT Specialist', 'Otorhinolaryngologist'],
    education: [{ degree: 'MBBS, MS — ENT' }],
    memberships: [],
    awards: ["Head of ENT Department — Rion's Hospital"],
  },
  {
    id: 18,
    name: 'Dr. Paras Dhhaka',
    specialty: 'Physiotherapist',
    qual: 'BPT — Physiotherapist',
    city: 'Gurgaon',
    location: "Rion's Hospital Basement, A-237, 40 Ft Road, Sector 110, Gurugram",
    clinic: 'BackBone Physiotherapy',
    fee: 1000,
    initials: 'PD',
    color: '#A32D2D',
    hours: 'Contact clinic for timings',
    phone: '',
    website: '',
    about: "Dr. Paras Dhhaka runs BackBone Physiotherapy in the basement of Rion's Hospital, Sector 110, Gurugram — specialising in spine rehabilitation, back pain, neck pain, and post-surgical physiotherapy.",
    services: ['Spine Rehabilitation', 'Back Pain Treatment', 'Neck Pain Treatment', 'Post-Surgical Physiotherapy', 'Sports Injury Rehabilitation', 'Electrotherapy', 'Manual Therapy', 'Orthopaedic Physiotherapy'],
    specializations: ['Physiotherapist', 'Spine Rehabilitation Specialist'],
    education: [{ degree: 'BPT' }],
    memberships: [],
    awards: [],
  },
  {
    id: 19,
    name: 'Dr. Venkata Kripa',
    specialty: 'Diabetologist',
    qual: 'MBBS, MD — Diabetes & Obesity',
    city: 'Hyderabad',
    location: 'Vijaya Nagar Colony, Hyderabad, Telangana',
    clinic: 'Venkata Kripa Diabetes Obesity Clinic',
    fee: 1000,
    initials: 'VK',
    color: '#2e7d32',
    hours: 'Contact clinic for timings',
    phone: '',
    website: '',
    about: 'Dr. Venkata Kripa runs the Venkata Kripa Diabetes Obesity Clinic in Vijaya Nagar Colony, Hyderabad — specialising in the management of Type 1 and Type 2 diabetes, obesity, and related metabolic disorders.',
    services: ['Diabetes Management (Type 1 & 2)', 'Obesity Treatment', 'Insulin Management', 'HbA1c Monitoring', 'Diabetic Foot Care', 'Weight Management', 'Metabolic Syndrome Treatment', 'Lifestyle Counselling'],
    specializations: ['Diabetologist', 'Obesity Specialist'],
    education: [{ degree: 'MBBS, MD' }],
    memberships: [],
    awards: [],
  },
];

const DoctorProfile = () => {
  const { id } = useParams();
  const doctor = allDoctors.find(d => d.id === parseInt(id));

  if (!doctor) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'sans-serif' }}>
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: 18, color: '#555', marginBottom: 16 }}>Doctor not found.</p>
          <Link to="/doctors" style={{ color: '#39a5d3', fontSize: 14 }}>Back to listing</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', fontFamily: 'sans-serif' }}>

      {/* Breadcrumb */}
      <div style={{ background: '#fff', borderBottom: '1px solid #eee', padding: '10px 32px', fontSize: 12, color: '#888' }}>
        <Link to="/" style={{ color: '#888', textDecoration: 'none' }}>Home</Link>
        <span style={{ margin: '0 6px' }}>›</span>
        <Link to="/doctors" style={{ color: '#888', textDecoration: 'none' }}>Find Doctors</Link>
        <span style={{ margin: '0 6px' }}>›</span>
        <span style={{ color: '#888' }}>{doctor.city}</span>
        <span style={{ margin: '0 6px' }}>›</span>
        <span style={{ color: '#888' }}>{doctor.specialty}</span>
        <span style={{ margin: '0 6px' }}>›</span>
        <span style={{ color: '#333' }}>{doctor.name}</span>
      </div>

      <div style={{ maxWidth: 1100, margin: '24px auto', padding: '0 24px', display: 'grid', gridTemplateColumns: '1fr 320px', gap: 24, alignItems: 'start' }}>

        {/* LEFT */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>

          {/* Header Card */}
          <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 28 }}>
            <div style={{ display: 'flex', gap: 24, marginBottom: 20 }}>
              <div style={{ width: 90, height: 90, borderRadius: 12, background: `${doctor.color}18`, color: doctor.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 700, border: `2px solid ${doctor.color}33`, flexShrink: 0 }}>
                {doctor.initials}
              </div>
              <div style={{ flex: 1 }}>
                <h1 style={{ fontSize: 22, fontWeight: 700, color: '#19354a', margin: '0 0 4px' }}>{doctor.name}</h1>
                <p style={{ fontSize: 14, color: '#555', margin: '0 0 4px' }}>{doctor.qual}</p>
                <p style={{ fontSize: 13, color: '#39a5d3', fontWeight: 600, margin: '0 0 8px' }}>{doctor.specializations.join(', ')}</p>
                <p style={{ fontSize: 13, color: '#555', margin: 0 }}>📍 {doctor.clinic} · {doctor.city}</p>
              </div>
            </div>

            {/* Info row */}
            <div style={{ borderTop: '1px solid #eee', paddingTop: 16, display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#444' }}>
                <span style={{ color: '#39a5d3', fontWeight: 600, minWidth: 60 }}>Hours:</span>
                <span>{doctor.hours}</span>
              </div>
              {doctor.phone && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#444' }}>
                  <span style={{ color: '#39a5d3', fontWeight: 600, minWidth: 60 }}>Phone:</span>
                  <a href={`tel:${doctor.phone}`} style={{ color: '#444', textDecoration: 'none' }}>{doctor.phone}</a>
                </div>
              )}
              {doctor.website && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#444' }}>
                  <span style={{ color: '#39a5d3', fontWeight: 600, minWidth: 60 }}>Website:</span>
                  <a href={doctor.website.startsWith('http') ? doctor.website : `https://${doctor.website}`} target="_blank" rel="noreferrer" style={{ color: '#39a5d3' }}>{doctor.website}</a>
                </div>
              )}
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#444' }}>
                <span style={{ color: '#39a5d3', fontWeight: 600, minWidth: 60 }}>Address:</span>
                <span>{doctor.location}</span>
              </div>
            </div>
          </div>

          {/* About */}
          <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 24 }}>
            <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 12, marginTop: 0 }}>About</h2>
            <p style={{ fontSize: 14, color: '#555', lineHeight: 1.7, margin: 0 }}>{doctor.about}</p>
          </div>

          {/* Services */}
          <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 24 }}>
            <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 16, marginTop: 0 }}>Services</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px 0' }}>
              {doctor.services.map(s => (
                <div key={s} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#444', paddingRight: 12 }}>
                  <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#39a5d3', flexShrink: 0, marginTop: 6 }} />
                  {s}
                </div>
              ))}
            </div>
          </div>

          {/* Education */}
          {doctor.education.length > 0 && (
            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 24 }}>
              <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 14, marginTop: 0 }}>Education</h2>
              {doctor.education.map((e, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#444', marginBottom: 8 }}>
                  <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#39a5d3', flexShrink: 0, marginTop: 6 }} />
                  {e.degree}
                </div>
              ))}
            </div>
          )}

          {/* Memberships */}
          {doctor.memberships.length > 0 && (
            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 24 }}>
              <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 14, marginTop: 0 }}>Memberships</h2>
              {doctor.memberships.map(m => (
                <div key={m} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#444', marginBottom: 8 }}>
                  <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#39a5d3', flexShrink: 0, marginTop: 6 }} />
                  {m}
                </div>
              ))}
            </div>
          )}

          {/* Awards */}
          {doctor.awards.length > 0 && (
            <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, padding: 24 }}>
              <h2 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', marginBottom: 14, marginTop: 0 }}>Awards & Recognitions</h2>
              {doctor.awards.map(a => (
                <div key={a} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#444', marginBottom: 8 }}>
                  <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#39a5d3', flexShrink: 0, marginTop: 6 }} />
                  {a}
                </div>
              ))}
            </div>
          )}

        </div>

        {/* RIGHT: Sidebar */}
        <div style={{ position: 'sticky', top: 20 }}>
          <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 12, overflow: 'hidden' }}>

            {/* Fee */}
            <div style={{ background: '#19354a', padding: '20px 20px', textAlign: 'center' }}>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)', marginBottom: 4 }}>Consultation Fee</div>
              <div style={{ fontSize: 32, fontWeight: 800, color: '#fff' }}>₹{doctor.fee}</div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)', marginTop: 2 }}>No Booking Fee</div>
            </div>

            {/* Clinic Info */}
            <div style={{ padding: '16px 20px', borderBottom: '1px solid #eee' }}>
              <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Clinic</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#19354a', marginBottom: 4 }}>{doctor.clinic}</div>
              <div style={{ fontSize: 12, color: '#666' }}>{doctor.location}</div>
            </div>

            {/* Hours */}
            <div style={{ padding: '14px 20px', borderBottom: '1px solid #eee' }}>
              <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Clinic Hours</div>
              <div style={{ fontSize: 13, color: '#333', fontWeight: 500 }}>{doctor.hours}</div>
            </div>

            {/* Phone */}
            {doctor.phone && (
              <div style={{ padding: '14px 20px', borderBottom: '1px solid #eee' }}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>Phone</div>
                <a href={`tel:${doctor.phone}`} style={{ fontSize: 14, fontWeight: 700, color: '#19354a', textDecoration: 'none' }}>
                  +91 {doctor.phone}
                </a>
              </div>
            )}

            {/* CTA */}
            <div style={{ padding: '16px 20px' }}>
              {doctor.phone ? (
                <a href={`tel:${doctor.phone}`} style={{ display: 'block', textAlign: 'center', background: '#E85A2C', color: '#fff', borderRadius: 8, padding: '13px 0', fontSize: 14, fontWeight: 700, textDecoration: 'none' }}>
                  Call to Book Appointment
                </a>
              ) : (
                <Link to="/book-appointment" style={{ display: 'block', textAlign: 'center', background: '#E85A2C', color: '#fff', borderRadius: 8, padding: '13px 0', fontSize: 14, fontWeight: 700, textDecoration: 'none' }}>
                  Book Appointment
                </Link>
              )}
              {doctor.website && (
                <a href={doctor.website.startsWith('http') ? doctor.website : `https://${doctor.website}`} target="_blank" rel="noreferrer"
                  style={{ display: 'block', textAlign: 'center', border: '1px solid #39a5d3', color: '#39a5d3', borderRadius: 8, padding: '11px 0', fontSize: 13, fontWeight: 600, textDecoration: 'none', marginTop: 10 }}>
                  Visit Website
                </a>
              )}
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default DoctorProfile;